import { z } from 'zod'

import { OperationLevelPermission } from '../auth-claims/permissions'
import { defineApi } from '../http'
import { helmRequestSchema } from '../locutus/guidance'
import { helmFieldFeaturesResponseSchema } from './field-features-response'

/**
 * `properties.group` values helm stamps on the features it emits from
 * `/guidance/path`. Groups not listed here (`boundary_ring_N`,
 * `interior_routing*`) are helm's internal scaffolding.
 */
export enum HelmFeatureGroup {
  FieldBoundary = 'field_boundary',
  HeadlandBoundary = 'headland_boundary',
  HeadlandSwaths = 'headland_swaths',
  InteriorHeadlandSwaths = 'interior_headland_swaths',
  InfillSwaths = 'infill_swaths',
  Infill = 'infill',
  BoundarySides = 'boundary_sides'
}

export const helmFeatureGroupSchema = z.enum(HelmFeatureGroup)

/**
 * Generates propagated guidance features (headlands, infill lines, and
 * boundary side annotations) for a field. Consumes the inspected field
 * structure produced by {@link boundaryInspectApi} — pass its response through
 * as `fieldFeatures` on RegionBounded requests so the ids overrides and
 * infillRegions reference stay consistent between the two calls.
 */
export const guidancePathApi = defineApi({
  method: 'POST',
  pathFor: () => '/guidance/path',
  name: 'GenerateGuidancePath',
  description:
    'Generate propagated guidance features (headlands, infill lines, boundary side annotations) for a field boundary and its infill regions.',
  requiredPermissions: OperationLevelPermission.ManagePlans,
  requestBodySchema: helmRequestSchema,
  responseSchema: helmFieldFeaturesResponseSchema
})
